import styled from "styled-components";
export var NoResultsContainer = styled.div.withConfig({
  displayName: "styles__NoResultsContainer",
  componentId: "sc-1y06f7a-0"
})(["display:flex;flex-direction:column;place-items:center;"]);
export var CopyContainer = styled.p.withConfig({
  displayName: "styles__CopyContainer",
  componentId: "sc-1y06f7a-1"
})(["font-size:16px;line-height:21px;margin-top:16px;margin-bottom:0;text-align:center;"]);